import { deleteValue, getValue, setValue } from "./indexedDB";
// import { AES, enc } from "crypto-js";
// import { isValidJSON } from "./cookie";

// const secretKey = btoa(process.env.REACT_APP_API_KEY);

// const encryptMobx = true;


export const customStorage = {

  async getItem(key) {
    const value = await getValue(key);
    // if (encryptMobx) {
    //   const decrypted = value ? AES.decrypt(value, secretKey).toString(enc.Utf8) : undefined;
    //   const parsed = isValidJSON(decrypted) ? JSON.parse(decrypted) : decrypted;
    //   return isValidJSON(parsed) ? JSON.parse(parsed) : parsed;
    // }
    // else return value
    return value
  },

  setItem(key, value) {
    // const encryptedValue = AES.encrypt(JSON.stringify(value), secretKey).toString();
    // setValue(key, encryptMobx ? encryptedValue : value)
    setValue(key, value)
  },

  removeItem(key) {
    deleteValue(key)
  },
}